/**
 * Кнопка перехода наверх страницы
 */
class PageUp {

  /**
   * 
   * @param {String} selector Селектор элемента
   */
  constructor(selector) {
    this.pageUp = document.querySelector(selector);
    // заканчиваем работу, если элемент отсутствует
    if (this.pageUp) {
      this._init();
    }
  }

  _init() {
    this.pageUp.addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo(0, 0);
    });
    window.addEventListener('scroll', this._handleWindowScroll.bind(this));    
  }

  // управляет показом и скрытием кнопки при скроллинге страницы
  _handleWindowScroll() {
    // показывается, если пользователь не находится наверху страницы
    (window.pageYOffset < 300) ?
      this.hide() :
      this.show();
  }

  /**
   * Hides element
   * @param {HTMLElement} item Element to hide
   */
  hide() {
    this.pageUp.classList.remove('page-up--visible');    
  }

  /**
   * Shows element
   * @param {HTMLElement} item Element to show
   */
  show() {
    this.pageUp.classList.add('page-up--visible');
  }
}

export default PageUp;